"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromoSettings_1 = require("../model/PromoSettings");

var PromoSettingsConverter_1 = require("./PromoSettingsConverter");

var ChangedWorkflowStateSettings_1 = require("../model/promo-settings-set/ChangedWorkflowStateSettings");

var CherryPickSettings_1 = require("../model/promo-settings-set/CherryPickSettings");

var DefaultWindowTypeSettings_1 = require("../model/promo-settings-set/DefaultWindowTypeSettings");

var ReplenishmentSettings_1 = require("../model/promo-settings-set/ReplenishmentSettings");

var RoundingRulesSettings_1 = require("../model/promo-settings-set/RoundingRulesSettings");

var ThresholdSettings_1 = require("../model/promo-settings-set/ThresholdSettings");
/**
 * Default implementation of PromoSettingsConverter.
 *
 * @author ZSr
 */


var PromoSettingsConverterImpl =
/*#__PURE__*/
function (_PromoSettingsConvert) {
  _inherits(PromoSettingsConverterImpl, _PromoSettingsConvert);

  function PromoSettingsConverterImpl() {
    _classCallCheck(this, PromoSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(PromoSettingsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromoSettings_1.PromoSettings(PromoSettings_1.PromoSettings.schema.id.valueOf(conversions.documentToClassId(source)), PromoSettings_1.PromoSettings.schema.thresholdSettings.valueOf(conversions.asObject(source, 'thresholdSettings', PromoSettingsConverterImpl.deserializeThresholdSettings(conversions))), PromoSettings_1.PromoSettings.schema.replenishmentSettings.valueOf(conversions.asObject(source, 'replenishmentSettings', PromoSettingsConverterImpl.deserializeReplenishmentSettings(conversions))), PromoSettings_1.PromoSettings.schema.defaultWindowType.valueOf(conversions.asObject(source, 'defaultWindowType', PromoSettingsConverterImpl.deserializeDefaultWindowType(conversions))), PromoSettings_1.PromoSettings.schema.cherryPickSettings.valueOf(conversions.asObject(source, 'cherryPickSettings', PromoSettingsConverterImpl.deserializeCherryPickSettings(conversions))), PromoSettings_1.PromoSettings.schema.changedWorkflowState.valueOf(conversions.asObject(source, 'changedWorkflowState', PromoSettingsConverterImpl.deserializeChangedWorkflowState(conversions))), PromoSettings_1.PromoSettings.schema.roundingRules.valueOf(conversions.asObject(source, 'roundingRules', PromoSettingsConverterImpl.deserializeRoundingRules(conversions))));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        thresholdSettings: conversions.asObject(source, 'thresholdSettings', PromoSettingsConverterImpl.serializeThresholdSettings(conversions)),
        replenishmentSettings: conversions.asObject(source, 'replenishmentSettings', PromoSettingsConverterImpl.serializeReplenishmentSettings(conversions)),
        defaultWindowType: conversions.asObject(source, 'defaultWindowType', PromoSettingsConverterImpl.serializeDefaultWindowType(conversions)),
        cherryPickSettings: conversions.asObject(source, 'cherryPickSettings', PromoSettingsConverterImpl.serializeCherryPickSettings(conversions)),
        changedWorkflowState: conversions.asObject(source, 'changedWorkflowState', PromoSettingsConverterImpl.serializeChangedWorkflowState(conversions)),
        roundingRules: conversions.asObject(source, 'roundingRules', PromoSettingsConverterImpl.serializeRoundingRules(conversions))
      });
      return result;
    }
    /**
     * Getter for ReplenishmentSettings serializer
     */

  }], [{
    key: "serializeReplenishmentSettings",
    value: function serializeReplenishmentSettings(conversions) {
      return function (object) {
        return {
          thresholdActivated: object.thresholdActivated,
          thresholdReplenishmentNotification: object.thresholdReplenishmentNotification,
          thresholdReplenishmentNotificationRel: object.thresholdReplenishmentNotificationRel
        };
      };
    }
    /**
     * Getter for ReplenishmentSettings deserializer
     */

  }, {
    key: "deserializeReplenishmentSettings",
    value: function deserializeReplenishmentSettings(conversions) {
      return function (document) {
        return new ReplenishmentSettings_1.ReplenishmentSettings(ReplenishmentSettings_1.ReplenishmentSettings.schema.thresholdActivated.valueOfField(document), ReplenishmentSettings_1.ReplenishmentSettings.schema.thresholdReplenishmentNotification.valueOfField(document), ReplenishmentSettings_1.ReplenishmentSettings.schema.thresholdReplenishmentNotificationRel.valueOfField(document));
      };
    }
    /**
     * Getter for RoundingRulesSettings serializer
     */

  }, {
    key: "serializeRoundingRules",
    value: function serializeRoundingRules(conversions) {
      return function (object) {
        return {
          volumes: object.volumes,
          prices: object.prices,
          percent: object.percent,
          kpisPrices: object.kpisPrices
        };
      };
    }
    /**
     * Getter for RoundingRulesSettings deserializer
     */

  }, {
    key: "deserializeRoundingRules",
    value: function deserializeRoundingRules(conversions) {
      return function (document) {
        return new RoundingRulesSettings_1.RoundingRulesSettings(RoundingRulesSettings_1.RoundingRulesSettings.schema.volumes.valueOfField(document), RoundingRulesSettings_1.RoundingRulesSettings.schema.prices.valueOfField(document), RoundingRulesSettings_1.RoundingRulesSettings.schema.percent.valueOfField(document), //Defaulting to 0, since we dont have DB updater enabled for this collection
        document.kpisPrices ? RoundingRulesSettings_1.RoundingRulesSettings.schema.kpisPrices.valueOfField(document) : 0);
      };
    }
    /**
     * Getter for DefaultWindowTypeSettings serializer
     */

  }, {
    key: "serializeDefaultWindowType",
    value: function serializeDefaultWindowType(conversions) {
      return function (object) {
        return {
          name: object.name,
          promoVolumeThresholdRel: object.promoVolumeThresholdRel,
          promoVolumeThresholdAbs: object.promoVolumeThresholdAbs,
          promoVolumeThresholdEnabled: object.promoVolumeThresholdEnabled,
          coordinatorApprovalNeeded: object.coordinatorApprovalNeeded,
          systemVolumeThresholdRel: object.systemVolumeThresholdRel,
          systemVolumeThresholdAbs: object.systemVolumeThresholdAbs,
          systemVolumeThresholdEnabled: object.systemVolumeThresholdEnabled
        };
      };
    }
    /**
     * Getter for DefaultWindowTypeSettings deserializer
     */

  }, {
    key: "deserializeDefaultWindowType",
    value: function deserializeDefaultWindowType(conversions) {
      return function (document) {
        return new DefaultWindowTypeSettings_1.DefaultWindowTypeSettings(DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.name.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.promoVolumeThresholdRel.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.promoVolumeThresholdAbs.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.promoVolumeThresholdEnabled.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.coordinatorApprovalNeeded.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.systemVolumeThresholdRel.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.systemVolumeThresholdAbs.valueOfField(document), DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema.systemVolumeThresholdEnabled.valueOfField(document));
      };
    }
    /**
     * Getter for CherryPickSettings serializer
     */

  }, {
    key: "serializeCherryPickSettings",
    value: function serializeCherryPickSettings(conversions) {
      return function (object) {
        return {
          cherryPickSettingsStatus: object.cherryPickSettingsStatus,
          thresholdTransactionSales: object.thresholdTransactionSales,
          thresholdTransactionVolume: object.thresholdTransactionVolume,
          thresholdProduct: object.thresholdProduct
        };
      };
    }
    /**
     * Getter for CherryPickSettings deserializer
     */

  }, {
    key: "deserializeCherryPickSettings",
    value: function deserializeCherryPickSettings(conversions) {
      return function (document) {
        return new CherryPickSettings_1.CherryPickSettings(CherryPickSettings_1.CherryPickSettings.schema.cherryPickSettingsStatus.valueOfField(document), CherryPickSettings_1.CherryPickSettings.schema.thresholdTransactionSales.valueOfField(document), CherryPickSettings_1.CherryPickSettings.schema.thresholdTransactionVolume.valueOfField(document), CherryPickSettings_1.CherryPickSettings.schema.thresholdProduct.valueOfField(document));
      };
    }
    /**
     * Getter for ChangedWorkflowStateSettings serializer
     */

  }, {
    key: "serializeChangedWorkflowState",
    value: function serializeChangedWorkflowState(conversions) {
      return function (object) {
        return {
          overallThresholdsActivated: object.overallThresholdsActivated,
          salesRelTh: object.salesRelTh,
          salesAbsTh: object.salesAbsTh,
          impactBM2RelTh: object.impactBM2RelTh,
          impactBM2AbsTh: object.impactBM2AbsTh,
          productThresholdsActivated: object.productThresholdsActivated,
          promoVolumeRelTh: object.promoVolumeRelTh,
          promoVolumeAbsTh: object.promoVolumeAbsTh,
          promoPriceRelTh: object.promoPriceRelTh,
          promoPriceAbsTh: object.promoPriceAbsTh,
          promoPurchasePriceRelTh: object.promoPurchasePriceRelTh,
          promoPurchasePriceAbsTh: object.promoPurchasePriceAbsTh,
          unitBackDiscountRelTh: object.unitBackDiscountRelTh,
          unitBackDiscountAbsTh: object.unitBackDiscountAbsTh
        };
      };
    }
    /**
     * Getter for ChangedWorkflowStateSettings deserializer
     */

  }, {
    key: "deserializeChangedWorkflowState",
    value: function deserializeChangedWorkflowState(conversions) {
      return function (document) {
        return new ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings(ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.overallThresholdsActivated.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.salesRelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.salesAbsTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.impactBM2RelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.impactBM2AbsTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.productThresholdsActivated.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoVolumeRelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoVolumeAbsTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoPriceRelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoPriceAbsTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoPurchasePriceRelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.promoPurchasePriceAbsTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.unitBackDiscountRelTh.valueOfField(document), ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema.unitBackDiscountAbsTh.valueOfField(document));
      };
    }
  }]);

  return PromoSettingsConverterImpl;
}(PromoSettingsConverter_1.PromoSettingsConverter);

exports.PromoSettingsConverterImpl = PromoSettingsConverterImpl;

PromoSettingsConverterImpl.serializeThresholdSettings = function (conversions) {
  return function (obj) {
    return {
      forecastCoordinatorConditionCheckEnabled: obj.forecastCoordinatorConditionCheckEnabled
    };
  };
};

PromoSettingsConverterImpl.deserializeThresholdSettings = function (conversions) {
  return function (document) {
    return new ThresholdSettings_1.ThresholdSettings(ThresholdSettings_1.ThresholdSettings.schema.forecastCoordinatorConditionCheckEnabled.valueOfField(document));
  };
};